<div class="annual-change-plan-container">
    <span *ngIf="annualPlan?.selected" class="selected-icon">
        <img alt="checkmark image" class="selected-icon-image"
             src="https://www-qa1.safeway.com/content/dam/DeliverySubscription/white.svg">
    </span>
    <p class="plan-type">{{annualPlan?.caption}}</p>
    <div class="sub-rectangle"></div>
    <h2 class="mt-2 value">{{annualPlan?.pricingDetailLine1}}</h2>
    <p class="first-text">{{properties.annualPlan.taxText}}{{annualPlan?.monthlyCost}}{{properties.annualPlan.monthText}}</p>
    <p class="renews">{{properties.annualPlan.renewelText}} {{annualAutoRenewsPrice}}.</p>
    <button 
      [ngClass]="isSnapVerified ? 'mt20' : ''"
      (click)="changePlanType(annualPlan?.code)" 
      *ngIf="!annualPlan?.selected" 
      class="select btn btn-primary">
        {{properties.annualPlan.selectAnnual}}
    </button>
    <button *ngIf="annualPlan?.selected" aria-label="Current Plan" class="current">{{properties.annualPlan.currentPlan}}</button>
</div>
